import { createReducer, on } from "@ngrx/store";
import { EAuthorizationActions } from "../actions";
import { EAuthClientsResponse } from "../models/EAuthClients";

export const createStandingAuthEauthKey = "createStandingAuthEauth";

export interface State {
  eauthClients: EAuthClientsResponse;
  hasServiceError: boolean;
  eauthClientCallSLOASuccess: boolean;
};

const initialCreateStandingAuthEauthState: State = {
  eauthClients: {
    areAllAccountHoldersIneligible: false,
    isAccountRestricted: false,
    eauthClients: []
  },
  hasServiceError: false,
  eauthClientCallSLOASuccess: false
};

export const createStandingAuthEauthClientsReducer = createReducer(
  initialCreateStandingAuthEauthState,
  on(EAuthorizationActions.loadCreateStandingAuthEAuthClientsSuccess, (_state, action) => {
    return {
      eauthClients: action.response,
      hasServiceError: false,
      eauthClientCallSLOASuccess: true
    }
  }),
  on(EAuthorizationActions.loadCreateStandingAuthEAuthClientsFailure, (_state, _action) => {
    return {
      ...initialCreateStandingAuthEauthState,
      hasServiceError: true,
      eauthClientCallSLOASuccess: false
    }
  }),
  on(EAuthorizationActions.loadCreateStandingAuthEAuthClients, (state, action) => {
    return {
        ...state,
        eauthClientCallSLOASuccess: false
    }
  }),
);